import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// True when the app is running inside the Shopify Admin iframe.
export const isEmbedded = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.has("host") || params.has("embedded") || window.top !== window.self;
  } catch {
    return true; // cross-origin access throws => we're framed
  }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Embedded: attach a fresh Shopify App Bridge session token (JWT) per request.
api.interceptors.request.use(async (config) => {
  try {
    if (isEmbedded() && window.shopify && typeof window.shopify.idToken === "function") {
      const token = await window.shopify.idToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    /* fall back to cookie auth */
  }
  return config;
});

export default api;
